import { newE2EPage } from '@stencil/core/testing';

describe('happyreact-form', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<happyreact-form></happyreact-form>');

    const element = await page.find('happyreact-form');
    expect(element).toHaveClass('hydrated');
  });
});
